import ImService from "@/server/ImService";
import { FocusSDK, isFocusEnv } from "@/utils";
import logger from "@/utils/logger";
import { setGlobalSentrySendLevel } from "@/utils/initSentry";
import { difference, get, keys, pick, set } from "lodash";
import { queryUserGlobalConfig, updateUserGlobalConfig } from "@/api/chat";
import Bus from "@/utils/bus";
import { message as toast } from "antd";
import {
  CloseMethod,
  DEFAULT_FILE_SECURITY_CONF,
  getPcSideConfig,
  getShowTipLocal,
  KEY_AI_LOCAL_MERGE,
  KEY_FILE_SECURITY_CONF,
  KEY_PROMPT_VER,
  KEY_TEAMCONFIG_VER,
  PC_CUSTOM_SIDEBAR_KEY,
  PC_SIDEBAR_KEY,
  KEY_AI_MERGE_RULE,
  DEFAULT_AI_MERGE_RULE,
  compareVersions,
  PC_SIDEBAR_KEY_VERSION
} from "@/utils/tools";
import { queryClientConfigVersion, queryClientConfig } from "@/api/user";
import { executePut } from "@/server/dvaHelper";
import { convertEmployeeToString } from "@/utils/chat/message";
import { convertUidToString } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import { stat } from "fs";
import { darkPrimaryColor, lightPrimaryColor, lightDefaultColor } from "@/utils/ui";
export interface TeamUserInfo {
  displayDeptName: string;
  account: string;
  ddAppId: string;
  headImg: string | null;
  mobile: string;
  realName: string;
  teamFullName: string;
  teamId: string;
  teamShortName: string;
}

export interface UserModel {
  refreshToken: string;
  refreshTokenExpireIn: number;
  accessToken: string;
  accessTokenExpireIn: number;
  account: string;
  ddAppId: string;
  headImg: string | null;
  nickName: string | null;
  realName: string;
  userId: string;
  selectedTeamId: string;
  teamUserInfoList: TeamUserInfo[];
  teamUserInfo: TeamUserInfo;
  team: TeamUserInfo;
}
// eslint-disable-next-line max-params
export function getDeptPositionDesc({
  deptName,
  titleName,
  userId,
  currentEmployee,
  unitName,
  userType
}: {
  deptName: string;
  titleName: string;
  userId?: string;
  currentEmployee?: any;
  unitName?: string;
  userType: string; // “1”：外部；  “2”：未认证； “3”：正式；  “4”：跨租户； “5”：跨平台；
}) {
  let desc;
  let e_dept_full_name: string = deptName;
  let e_position = titleName;
  // 唤起联系人选择器不显示当前账户自己的部门和岗位信息
  if (userId && currentEmployee && userId === currentEmployee.userId) {
    e_dept_full_name = currentEmployee.e_dept_full_name || "";
    e_position = currentEmployee.e_position || "";
  }
  if (userType === "1") {
    desc = e_position;
  } else if (e_dept_full_name?.includes("-")) {
    e_dept_full_name = e_dept_full_name.split("-").pop() || "";
    desc = e_dept_full_name + "-" + e_position;
  } else if (e_dept_full_name && !e_dept_full_name?.includes("-") && e_position) {
    desc = e_dept_full_name + "-" + e_position;
  } else if (!e_dept_full_name && e_position) {
    desc = e_position;
  } else if (e_dept_full_name && !e_position) {
    desc = e_dept_full_name + "-暂无岗位";
  } else {
    desc = "暂未填写";
  }
  desc = unitName && e_dept_full_name !== unitName ? unitName + "-" + desc : desc;
  // desc = unitName ? unitName + "-" + desc : desc;
  return desc;
}

export function isSelf(self: any, other: Partial<UserModel>) {
  return (
    self.userId === other.userId &&
    self.ddAppId === other.ddAppId &&
    self?.teamUserInfo?.teamId === other.selectedTeamId
  );
}

export interface AppModel {
  appId: string;
  deviceId: string;
  client:
    | "MAC"
    | "WINDOWS"
    | "LINUX"
    | "AIX"
    | "ANDROID"
    | "FREEBSD"
    | "OPENBSD"
    | "SUNOS"
    | "CYGWIN"
    | "NETBSD";
}
// 用户 该结构的用户信息用于网络请求
export interface UserInfo {
  app: string;
  teamId: string;
  userId: string;
  tenantCode?: string;
  account?: string;
  imageUrl?: string;
  realName?: string;
  ddAppId?: string;
  userType?: string; // “1”：外部；  “2”：未认证； “3”：正式；  “4”：跨租户； “5”：跨平台；
  accessToken?: string;
  appId?: string;
  deviceId?: string;
  client?: string;
  name?: string;
}

export interface ICommonConfig {
  focus_public_key: string;
  websiteAddress: string;
  jdSummary?: boolean;
}

export interface ISideThemes {
  primary?: string;
  secondary?: string;
  activePrimary?: string;
  iconPrimary?: string;
}

export interface TouristModePath {
  path: string;
  type: string;
  name: string;
}

export interface UserState {
  isLogin: boolean;
  userData: {
    user: UserModel;
    app: AppModel;
  };
  userInfo: UserInfo;
  themes: string;
  sideThemes: ISideThemes;
  tablePasteFormat: string;
  readMsgCustom: string;
  // 新增置顶会话模式
  topUpModeCustom: string;
  // 新增输入框模式
  editorMode: string;
  showLogoutModalText: string;
  upgradeState: Record<string, any>;
  clientConfig: Record<string, any>;
  commonConfig: ICommonConfig;
  logActive: boolean;
  promptData: Record<string, any>;
  navPopInfo: Record<string, any>;
  // 租户配置
  teamConfig: Record<string, any>;
  teamConfigVer: number;
  userMedalWall: any;
  pcFuncInfoMap: Map<string, any>;
  touristModePath: TouristModePath;
}

const UPGRADE_CHECK_TYPES = ["updateDownloaded", "updateDownloading"];

export const GLOBAL_CLIENT_CONFIG = [
  "allNotice",
  "unitNotice",
  "titleNotice",
  "deptNotice",
  "quickReply"
];

let themes = "";
const getThemes = () => {
  if (themes) {
    return themes;
  }
  themes = isFocusEnv()
    ? JSON.parse(FocusSDK.getConfigData())?.newThemeUpgrade || "qiongji"
    : localStorage?.getItem?.("newThemeUpgrade") || "qiongji";
  return themes;
};
const getSideThemes = () => {
  const curr = getThemes();
  switch (curr) {
    case "qiongji":
    case "miyou":
    case "shuangji":
      return {
        activePrimary: lightPrimaryColor,
        iconPrimary: lightDefaultColor
      };
    default:
      return {
        activePrimary: lightPrimaryColor,
        iconPrimary: darkPrimaryColor
      };
  }
};

export default {
  namespace: "user",
  state: {
    upgradeState: {},
    showLogoutModalText: "",
    isLogin: false,
    userData: {},
    userInfo: null,
    promptData: {},
    userMedalWall: [],
    themes: getThemes(),
    tablePasteFormat:
      (isFocusEnv()
        ? JSON.parse(FocusSDK.getConfigData())?.tablePasteFormat
        : localStorage.getItem("tablePasteFormat")) || "text",
    readMsgCustom:
      (isFocusEnv()
        ? JSON.parse(FocusSDK.getConfigData())?.readMsgCustom
        : localStorage.getItem("readMsgCustom")) || "last",
    // 新增置顶会话模式
    topUpModeCustom:
      (isFocusEnv()
        ? JSON.parse(FocusSDK.getConfigData())?.topUpModeCustom
        : localStorage.getItem("topUpModeCustom")) || "horizon",
    // 新增输入框模式
    editorMode:
      (isFocusEnv()
        ? JSON.parse(FocusSDK.getConfigData())?.editorMode
        : localStorage.getItem("editorMode")) || "new",
    clientConfig: {},
    commonConfig: {},
    logActive: false,
    sideThemes: getSideThemes(),
    navPopInfo: {},
    teamConfig: {},
    teamConfigVer: 0,
    pcFuncInfoMap: {},
    touristModePath: {}
  },
  reducers: {
    setTouristModePath(state: UserState, { payload }: any) {
      return { ...state, touristModePath: payload };
    },
    setShowLogoutModal(state: UserState, { payload }: any) {
      return { ...state, showLogoutModalText: payload };
    },
    setUserData(state: UserState, { payload: userData }: { payload: any }) {
      if (userData?.user) {
        // 登录类型
        let type = (userData?.user?.loginType || "").toLowerCase();
        if (type && type === "ca") {
          type = "ca";
        } else {
          type = "normal";
        }
        userData.user.loginType = type;
      }
      return {
        ...state,
        userData,
        isLogin: true,
        userInfo: {
          userId: userData?.user?.userId,
          teamId: userData?.user?.selectedTeamId || userData?.user?.teamUserInfo?.teamId,
          app: userData?.user?.ddAppId
        }
      };
    },
    setCommonConfig(state: UserState, { payload: commonConfig }: { payload: ICommonConfig }) {
      logger.debug("setCommonConfig,", commonConfig);
      return { ...state, commonConfig };
    },
    setThemes(state: UserState, { payload: data }: { payload: string }) {
      logger.debug("setThemes,", data);
      if (isFocusEnv()) {
        FocusSDK.setConfigData("newThemeUpgrade", data);
      } else {
        localStorage.setItem("newThemeUpgrade", data);
      }
      return { ...state, themes: data };
    },
    setReadMsgCustom(state: UserState, { payload: data }: { payload: string }) {
      logger.debug("setReadMsgCustom,", data);
      if (isFocusEnv()) {
        FocusSDK.setConfigData("readMsgCustom", data);
      } else {
        localStorage.setItem("readMsgCustom", data);
      }
      return { ...state, readMsgCustom: data };
    },
    // 新增会话置顶模式
    setTopUpModeCustom(state: UserState, { payload: data }: { payload: any }) {
      console.log("设置请求到的===", data);

      if (isFocusEnv()) {
        FocusSDK.setConfigData("topUpModeCustom", data.topConfig);
      } else {
        localStorage.setItem("topUpModeCustom", data.topConfig);
      }
      return { ...state, topUpModeCustom: data.topConfig };
    },
    updateTopUpModeCustom(state: UserState, { payload: data }: { payload: string }) {
      const { userInfo } = state;
      // 发送接口
      updateUserGlobalConfig({
        topConfig: data === "horizon" ? 0 : 1,
        pin: userInfo.userId,
        app: userInfo.app,
        teamId: userInfo.teamId
      })
        .then((res) => {
          logger.debug("updateTopUpModeCustom,", data);
          if (isFocusEnv()) {
            FocusSDK.setConfigData("topUpModeCustom", data);
          } else {
            localStorage.setItem("topUpModeCustom", data);
          }
          toast.success("设置成功");
        })
        .catch((e) => {})
        .finally(() => {});
      // logger.debug("setTopUpModeCustom,", data);
      // if (isFocusEnv()) {
      //   FocusSDK.setConfigData("topUpModeCustom", data);
      // } else {
      //   localStorage.setItem("topUpModeCustom", data);
      // }
      // toast.success("设置成功");
      return { ...state, topUpModeCustom: data };
    },
    // 新增输入框模式
    setEditorMode(state: UserState, { payload: data }: { payload: string }) {
      logger.debug("setEditorMode,", data);
      if (isFocusEnv()) {
        FocusSDK.setConfigData("editorMode", data);
      } else {
        localStorage.setItem("editorMode", data);
      }
      toast.success("切换成功");
      return { ...state, editorMode: data };
    },
    setSideThemes(state: UserState, { payload: data }: { payload: ISideThemes }) {
      return {
        ...state,
        sideThemes: {
          ...state.sideThemes,
          ...data
        }
      };
    },
    setTablePasteFormat(state: UserState, { payload: data }: { payload: string }) {
      if (isFocusEnv()) {
        FocusSDK.setConfigData("tablePasteFormat", data);
      } else {
        localStorage.setItem("tablePasteFormat", data);
      }
      return { ...state, tablePasteFormat: data };
    },
    setUserInfo(state: UserState, { payload }: { payload: any }) {
      return {
        ...state,
        userInfo: {
          teamId: payload?.teamUserInfo?.teamId,
          userId: payload?.userId,
          app: payload?.ddAppId
        }
      };
    },
    setUpgradeState(state: UserState, { payload }: any) {
      return { ...state, upgradeState: payload };
    },
    updateUpgradeState(state: UserState, { payload }: any) {
      const { upgradeState: rawUpgradeState } = state;
      return { ...state, upgradeState: { ...rawUpgradeState, ...payload } };
    },
    clearUserData(state: UserState) {
      const { autoUpgradeDownloads } = state.upgradeState;
      return {
        ...state,
        promptData: {},
        upgradeState: { autoUpgradeDownloads, visible: false },
        userInfo: {},
        sideThemes: getSideThemes(),
        navPopInfo: {},
        teamConfig: {},
        teamConfigVer: 0,
        userMedalWall: [],
        clientConfig: {}
      };
    },
    setClientConfig(state: UserState, { payload }: any) {
      return { ...state, clientConfig: payload };
    },
    updateClientConfig(state: UserState, { payload }: any) {
      return { ...state, clientConfig: { ...state.clientConfig, ...payload } };
    },
    setLogActive(state: UserState, { payload }: any) {
      return { ...state, logActive: payload };
    },
    setPromptData(state: UserState, { payload }: any) {
      const promptData = state.promptData;
      return {
        ...state,
        promptData: { ...promptData, ...payload }
      };
    },
    updateNavPopInfo(state: UserState, { payload }: any) {
      const { navPopInfo: rawInfo } = state;
      return {
        ...state,
        navPopInfo: {
          ...rawInfo,
          ...payload
        }
      };
    },
    setTeamConfig(state: UserState, { payload }: any) {
      const { version, value } = payload;
      const newValue = {
        ...state,
        teamConfig: value
      };
      if (version) {
        newValue.teamConfigVer = version;
      }
      return {
        ...state,
        ...newValue
      };
    },
    updateTeamConfig(state: UserState, { payload }: any) {
      const oldData = state.teamConfig;
      const newValue = {
        ...state,
        teamConfig: {
          ...oldData,
          payload
        }
      };
      return {
        ...state,
        ...newValue
      };
    },
    setUserMedalWall(state: UserState, { payload }: any) {
      return {
        ...state,
        userMedalWall: [...payload]
      };
    },
    setPcFuncInfoMap(state: UserState, { payload }: any) {
      return {
        ...state,
        pcFuncInfoMap: payload
      };
    }
  },
  effects: {
    *getWebUserData({ payload }: any, { call, put }: any) {
      const result = payload.userData;
      yield put({
        type: "setUserData",
        payload: {
          user: {
            ...result,
            realName: result.teamUserInfo.realName,
            team: result.teamUserInfo,
            teamUserInfoList: [result.teamUserInfo],
            selectedTeamId: result.teamUserInfo.teamId
          }
        }
      });
    },
    // 全局client配置
    *updateGlobalClientConfig({ payload }: any, { call, put, select }: any) {
      const level = payload?.sentrySwitch || 3;
      const llmAI = payload?.llmAI || 0;
      const userState = yield select(({ user }: { user: UserState }) => user);
      const { userInfo } = userState;
      const uid = {
        pin: userInfo.userId,
        teamId: userInfo?.teamId,
        app: userInfo?.app
      };
      yield setGlobalSentrySendLevel(level);
      if (isFocusEnv()) {
        yield FocusSDK.setSentrySendLevel(level);
        if (llmAI) {
          yield ImService.getInstance()?.initLLMTransport();
          yield FocusSDK.launchAIChatSession(
            `aiRobot:dd.notice:focus.bot:${convertUidToString(uid)}:chat`,
            () => {},
            false
          );
        }
      }
      const res = yield queryUserGlobalConfig(uid) || {};
      console.log("queryUserGlobalConfig====", res);

      if (payload) {
        const combin = {
          ...payload,
          ...pick(res, GLOBAL_CLIENT_CONFIG)
        };
        if (combin) {
          combin.quickReply = combin.quickReply === 0 ? 0 : 1;
        }
        yield put({
          type: "setClientConfig",
          payload: combin
        });
        // 新增设置请求到的置顶模式
        yield put({
          type: "setTopUpModeCustom",
          payload: {
            topConfig: res.topConfig === 0 ? "horizon" : "vertical"
          }
        });
      }
    },
    // 通用comm配置
    *updateGlobalCommConfig({ payload }: any, { select, call, put }: any) {
      const { service } = payload;
      const userState = yield select(({ user }: { user: UserState }) => user);
      if (userState?.commonConfig && Object.keys(userState?.commonConfig).length > 0) {
        return userState?.commonConfig;
      } else if (service) {
        try {
          const res = yield (service as any)?.focusService?.commonConfig();
          if (res) {
            yield put({
              type: "setCommonConfig",
              payload: res
            });
          }
        } catch (e) {}
      }
    },
    *updateUpgradeVisable({ payload }: any, { select, call, put }: any) {
      const userState = yield select(({ user }: { user: UserState }) => user);
      const { upgradeData, newVersion, buildVersion, updateType, downloadUrl = "" } = userState?.upgradeState || {};
      console.log(`tj:>updateUpgradeVisable>>>>downloadUrl>>`, downloadUrl);
      yield put({
        type: "updateUpgradeState",
        payload: {
          inAutoBackground: false,
          visible: false
        }
      });
      // FocusSDK.checkUpdate(false, newVersion, `${buildVersion}`, updateType);
      if (upgradeData) {
        const { type } = upgradeData;
        if (!type || !UPGRADE_CHECK_TYPES.includes(type)) {
          yield put({
            type: "updateUpgradeState",
            payload: {
              inAutoBackground: false,
              visible: false
            }
          });
          FocusSDK.checkUpdate(false, newVersion, `${buildVersion}`, updateType, downloadUrl);
          return;
        }
      }
      yield put({
        type: "updateUpgradeState",
        payload: {
          ...payload,
          inAutoBackground: false
        }
      });
    },
    *loadLocalConfig({ payload }: any, { select, call, put }: any) {
      // 获取本地配置
      try {
        let res = yield ImService.getInstance()?.getAppModuleVersion(KEY_TEAMCONFIG_VER);
        if (res) {
          res = JSON.parse(res);
          const oldVal = typeof res?.value === "string" ? JSON.parse(res?.value) : res?.value;
          // 更新智能聚合配置
          if (oldVal) {
            const imservice = ImService.getInstance();
            const {
              aiMergeWhiteList = "",
              aiMergeDuration = "3600000",
              aiMergeKeywords = ""
            } = oldVal;
            let aiMergeRule = oldVal[KEY_AI_MERGE_RULE] || {};
            aiMergeRule = typeof aiMergeRule === "string" ? JSON.parse(aiMergeRule) : aiMergeRule;
            yield imservice.setAIMergeConfig({
              keywords: aiMergeKeywords.split(","),
              duration: Number(aiMergeDuration),
              whitelist: aiMergeWhiteList.split(","),
              ...aiMergeRule
            });
          }
        }
      } catch (e) {
        console.log("loadLocalConfig>>error", e);
      }
    },
    // 通用配置
    // eslint-disable-next-line complexity
    *queryTeamConfig({ payload }: any, { select, call, put }: any) {
      // thirdMap 三方应用列表，237改为导航应用
      const { nav = [], settings = {}, thirdMap, localConfigData = {} } = payload;
      const mainIds = nav.map((i: any) => i.name);
      const userState = yield select(({ user }: { user: UserState }) => user);
      const hasThirdData = (keys(thirdMap) || []).length > 0;
      let { teamConfigVer = 0, userInfo, touristModePath } = userState;
      const { settings: localSetting } = localConfigData;
      // 获取本地配置
      try {
        let res = yield ImService.getInstance()?.getAppModuleVersion(KEY_TEAMCONFIG_VER);
        if (res) {
          res = JSON.parse(res);
        }
        if (!teamConfigVer && res?.version) {
          teamConfigVer = res?.version;
        }
        const data = yield queryClientConfigVersion({
          version: `${teamConfigVer}`,
          name: "teamConfig"
        });
        const newValue: any = {};
        let oldVer = "";
        let newVer = "";
        const oldVal = typeof res?.value === "string" ? JSON.parse(res?.value) : res?.value;
        if (data?.value) {
          const val = JSON.parse(data.value);
          newValue.version = data.version;
          newValue.value = {
            ...oldVal,
            ...val
          };
          ImService.getInstance()?.setAppVersion(JSON.stringify(newValue), KEY_TEAMCONFIG_VER);
        } else {
          newValue.version = teamConfigVer;
          newValue.value = oldVal;
        }
        if (!get(newValue.value, KEY_FILE_SECURITY_CONF)) {
          set(newValue.value, KEY_FILE_SECURITY_CONF, JSON.stringify(DEFAULT_FILE_SECURITY_CONF));
        }
        // 默认智能聚合配置
        if (!get(newValue.value, KEY_AI_MERGE_RULE)) {
          set(newValue.value, KEY_AI_MERGE_RULE, JSON.stringify(DEFAULT_AI_MERGE_RULE));
        }
        // 导航
        const oldNavs = getPcSideConfig(newValue.value, {
          key: "items"
        });
        let newNavs = [...oldNavs];
        if (oldNavs?.length) {
          newNavs = oldNavs.filter((i: any) => {
            if (!i.applicationKey || !i.applicationId) {
              return true;
            } else {
              const uuid = `${i.applicationId}_${i.sceneId}`;
              return !!thirdMap[uuid];
            }
          });
          newNavs = newNavs.map((i: any) => {
            // 237 - uuid: i.applicationId_i.sceneId
            const uuid = i.applicationId && i.sceneId ? `${i.applicationId}_${i.sceneId}` : "";
            if (thirdMap[uuid] && thirdMap[uuid]?.svg) {
              i.svg = thirdMap[uuid]?.svg;
            }
            return {
              ...i,
              // 更新
              cnName: thirdMap[uuid]?.name || i.cnName,
              avatar: thirdMap[uuid]?.icon || i.avatar,
              ...pick(thirdMap[uuid], ["sceneId", "openType", "homeUrl"]),
              uuid: uuid,
              name: uuid ? uuid : i.name
            };
          });
          if (newValue?.value && difference(oldNavs, newNavs)?.length) {
            const useCustom = newValue?.value[PC_CUSTOM_SIDEBAR_KEY];
            if (useCustom) {
              let val = getPcSideConfig(newValue.value, {
                pKey: PC_CUSTOM_SIDEBAR_KEY,
                getDefault: false
              });
              // 已存版本号
              oldVer = get(val, PC_SIDEBAR_KEY_VERSION);
              val = {
                ...val,
                items: [...newNavs]
              };
              // 导航版本
              newVer = get(newNavs, PC_SIDEBAR_KEY_VERSION);
              // 导航版本比较
              if (
                newVer &&
                oldVer &&
                typeof oldVer === "string" &&
                compareVersions(newVer, oldVer) > 0
              ) {
                set(val, "needUpdate", true);
              }
              newValue.value[PC_CUSTOM_SIDEBAR_KEY] = JSON.stringify(val);
              if (hasThirdData) {
                ImService.getInstance()?.setAppVersion(
                  JSON.stringify(newValue),
                  KEY_TEAMCONFIG_VER
                );
              }
            } else if (newValue?.value[PC_SIDEBAR_KEY]) {
              let val = getPcSideConfig(newValue.value, {
                pKey: PC_SIDEBAR_KEY,
                getDefault: false
              });
              val = {
                ...val,
                items: [...newNavs]
              };
              newValue.value[PC_SIDEBAR_KEY] = JSON.stringify(val);
            }
          }
        }
        if (newValue?.value.aiMergeRule) {
          newValue.value.aiMergeRule =
            typeof newValue.value.aiMergeRule === "string"
              ? JSON.parse(newValue.value.aiMergeRule)
              : newValue.value.aiMergeRule;
        }
        yield executePut(put, "setTeamConfig", {
          ...newValue
        });
        // 更新智能聚合配置
        const imservice = ImService.getInstance();
        if (newValue?.value) {
          const {
            aiMergeWhiteList = "",
            aiMergeDuration = "3600000",
            aiMergeKeywords = "",
            aiMergeRule = {}
          } = newValue.value;
          const whitelist = aiMergeWhiteList.split(",") || [];
          // 判断是否白名
          let aiMergeLocal = localConfigData?.settings?.[KEY_AI_LOCAL_MERGE];
          if (aiMergeLocal === undefined && whitelist.includes(userInfo?.userId)) {
            yield FocusSDK.setConfigData(`settings|${KEY_AI_LOCAL_MERGE}`, true);
            aiMergeLocal = true;
          }
          newValue.value = {
            ...newValue.value,
            [KEY_AI_LOCAL_MERGE]: aiMergeLocal,
            aiMergeRule
          };
          yield executePut(put, "setTeamConfig", {
            ...newValue
          });
          yield imservice.setAIMergeConfig({
            keywords: aiMergeKeywords.split(","),
            duration: Number(aiMergeDuration),
            whitelist: aiMergeWhiteList.split(","),
            [KEY_AI_LOCAL_MERGE]: aiMergeLocal,
            ...aiMergeRule
          });
        }
        // 通栏
        if (newValue?.value?.promptBar) {
          const promptData =
            typeof newValue?.value?.promptBar === "string"
              ? JSON.parse(newValue?.value?.promptBar)
              : newValue?.value?.promptBar;
          if (promptData?.closeMethod === CloseMethod.NO_CLOSE || promptData?.isShow === false) {
            yield executePut(put, "setPromptData", { ...promptData });
          } else {
            const d = yield ImService.getInstance()?.getAppModuleVersion(KEY_PROMPT_VER);
            const isShow = getShowTipLocal(d);
            yield executePut(put, "setPromptData", { ...promptData, isShow });
          }
        }
        // 登录前选中
        const pcSideConfig = getPcSideConfig(newValue?.value);
        if (
          touristModePath &&
          touristModePath.name &&
          pcSideConfig &&
          pcSideConfig.items &&
          pcSideConfig.items.length
        ) {
          const itemPath = pcSideConfig.items.find((i: any) => i.name === touristModePath.name);
          if (itemPath && itemPath.name) {
            setTimeout(() => {
              Bus.emit(`nav:default-nav-click:${itemPath.name}`);
            });
            return;
          }
        }
        // 选中
        // tj 导航默认选中，237 增加场景id（新增key)
        const defaultSelectScene = getPcSideConfig(newValue?.value, {
          key: "defaultSelectScene",
          pKey: PC_SIDEBAR_KEY,
          getDefault: false
        });
        const defaultSelect = getPcSideConfig(newValue?.value, {
          key: "defaultSelect",
          pKey: PC_SIDEBAR_KEY,
          getDefault: false
        });
        const uuid = `${defaultSelect}_${defaultSelectScene}`;
        if (defaultSelect && typeof defaultSelect === "string") {
          const appInfo = get(
            settings,
            `autoOpen[${userInfo?.userId}:${userInfo?.app}:${userInfo?.teamId}]`
          );
          const items = getPcSideConfig(newValue?.value, {
            key: "items",
            pKey: PC_SIDEBAR_KEY,
            getDefault: false
          });
          const canJump =
            !appInfo &&
            (items?.map?.((item: any) => item.name)?.includes?.(defaultSelect) ||
              !!thirdMap[defaultSelect] ||
              !!thirdMap[uuid]);
          if (canJump) {
            // 保证导航注册完事件之后再触发跳转，导航会渲染两遍，获取到配置之后再渲染一遍，这时不会再执行跳转
            setTimeout(() => {
              Bus.emit(`nav:default-nav-click:${defaultSelect}`);
            });
          }
        }
      } catch (e) {}
    },
    // 获取桌面端左侧导航配置信息
    *queryFuncInfoData({ payload }: any, { put }: any) {
      try {
        const funcInfoDataStr = yield queryClientConfig({
          name: "functionNameAndIcon"
        });
        const funcInfoData = JSON.parse(funcInfoDataStr);
        const map = new Map();
        funcInfoData["functionNameAndIcons"].forEach((item: any) => {
          map.set(item.pcFunctionId, item);
        });
        // setPcFuncInfoMap(map);
        yield executePut(put, "setPcFuncInfoMap", map);
      } catch (e) {
        console.error(e);
      }
    },
    // 更新
    *updateTeamConfig({ payload }: any, { select, call, put }: any) {
      const userState = yield select(({ user }: { user: UserState }) => user);
      const { teamConfig = {}, teamConfigVer } = userState;
      const newConfig = {
        ...teamConfig,
        ...payload
      };
      yield executePut(put, "setTeamConfig", {
        value: newConfig
      });
      const data = {
        value: newConfig,
        version: teamConfigVer
      };
      ImService.getInstance()?.setAppVersion(JSON.stringify(data), KEY_TEAMCONFIG_VER);
    }
  },
  subscriptions: {
    "session-event"({ dispatch }: any, onError: (reason?: any) => void) {
      Bus.on("chat_message_multiSync_event:im", (data: any) => {
        console.log("getAllSessionList===session-event", data);

        const { quick_reply_config = undefined, topConfig = undefined } = data || {};
        if (quick_reply_config !== undefined) {
          dispatch({
            type: "updateClientConfig",
            payload: {
              quickReply: quick_reply_config
            }
          });
        }
        if (topConfig !== undefined) {
          dispatch({
            type: "setTopUpModeCustom",
            payload: {
              topConfig: topConfig === 0 ? "horizon" : "vertical"
            }
          });
        }
      });
    }
  }
};
